import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { LOCALE_LABELS, SUPPORTED_LOCALES, setLocale, type SupportedLocale } from '@/i18n';

export function useLocale() {
  const { locale } = useI18n();

  const current = computed<SupportedLocale>(() => locale.value as SupportedLocale);

  function set(value: SupportedLocale): void {
    setLocale(value);
  }

  return {
    current,
    set,
    options: SUPPORTED_LOCALES.map((code) => ({ code, label: LOCALE_LABELS[code] })),
  };
}
